import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getCSVData = createAsyncThunk('GET CSV DATA', async (data, thunkAPI) => {
  let query = `?page=${data?.page}&pageSize=${data?.pageSize}&limit=${data?.limit}&text=${data?.text}&bookingStatus=${data?.bookingStatus}&provider=${data?.provider}&refundability=${data.refundability}&currency=${data.currency}&paymentGateway=${data.paymentGateway}&startDate=${data?.startDate}&endDate=${data?.endDate}&category=${data?.category}&sorting=${data?.sorting}&userType=${data?.userType}&travelStartDate=${data.travelStartDate}&travelEndDate=${data.travelEndDate}&agencyName=${data?.agencyName}`;
  if (data?.agencyId) {
    query = `?agencyId=${data?.agencyId}&page=${data?.page}&pageSize=${data?.pageSize}&limit=${data?.limit}&text=${data?.text}&bookingStatus=${data?.bookingStatus}&provider=${data?.provider}&refundability=${data?.refundability}&currency=${data.currency}&paymentGateway=${data.paymentGateway}&startDate=${data?.startDate}&endDate=${data?.endDate}&category=${data?.category}&sorting=${data?.sorting}&userType=${data?.userType}&travelStartDate=${data.travelStartDate}&travelEndDate=${data.travelEndDate}&agencyName=${data?.agencyName}`;
  }
  const response = await axios.get(`${URL.CSV_DOWNLOAD}${query}`, thunkAPI);
  return response.data;
});

export const getCSVDataResort = createAsyncThunk('GET CSV DATA HOTEL', async (data, thunkAPI) => {
  let query = `?csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&cogs_paid_date=${data.cogsPaidDate}&refundable=${data.refundable}&booking_status=${data.bookingStatus}&currency=${data.currency}&provider_name=${data.provider_name}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}`;

  if (data?.agencyId) {
    query = `?agency_id=${data?.agencyId}&csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&cogs_paid_date=${data.cogsPaidDate}&refundable=${data.refundable}&booking_status=${data.bookingStatus}&currency=${data.currency}&provider_name=${data.provider_name}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}`;
  }
  const response = await axiosAdmin.get(`${URL.RESORT_BOOKINGS}${query}`, thunkAPI);
  return response.data;
});

export const getCSVDataHotel = createAsyncThunk('GET CSV DATA HOTEL', async (data, thunkAPI) => {
  let query = `?csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&cogs_paid_date=${data.cogsPaidDate}&refundable=${data.refundable}&booking_status=${data.bookingStatus}&currency=${data.currency}&provider_name=${data.provider_name}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}`;

  if (data?.agencyId) {
    query = `?agency_id=${data?.agencyId}&csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&cogs_paid_date=${data.cogsPaidDate}&refundable=${data.refundable}&booking_status=${data.bookingStatus}&currency=${data.currency}&provider_name=${data.provider_name}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}`;
  }
  const response = await axiosAdmin.get(`${URL.HOTEL}${query}`, thunkAPI);
  return response.data;
});

export const getCSVDataFlight = createAsyncThunk('GET CSV DATA FLIGHT', async (data, thunkAPI) => {
  let query = `?csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&cogs_paid_date=${data.cogsPaidDate}&refundable=${data.refundable}&booking_status=${data.bookingStatus}&currency=${data.currency}&provider_name=${data.provider_name}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}`;

  if (data?.agencyId) {
    query = `?agency_id=${data?.agencyId}&csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&cogs_paid_date=${data.cogsPaidDate}&refundable=${data.refundable}&booking_status=${data.bookingStatus}&currency=${data.currency}&provider_name=${data.provider_name}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}`;
  }
  const response = await axiosAdmin.get(`${URL.FLIGHT}${query}`, thunkAPI);
  return response.data;
});

export const getCSVDataCar = createAsyncThunk('GET CSV DATA CAR', async (data, thunkAPI) => {
  let query = `?csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&provider_name=${data.provider}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&sorting=${data.sorting}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&payment_type=${data.paymentMethodTypes}&agency_id=${data?.agencyId}`;

  if (data?.agencyId) {
    query = `?agency_id=${data?.agencyId}&csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&provider_name=${data.provider}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&sorting=${data.sorting}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&payment_type=${data.paymentMethodTypes}&agency_id=${data?.agencyId}`;
  }
  const response = await axiosAdmin.get(`${URL.CAR}${query}`, thunkAPI);
  return response.data;
});

export const getCSVDataActivity = createAsyncThunk('GET CSV DATA ACTIVITY', async (data, thunkAPI) => {
  let query = `?csv=true&page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&agency_id=${data?.agencyId || ''}`;

  const response = await axiosAdmin.get(`${URL.ACTIVITY_V2}${query}`, thunkAPI);
  return response.data;
});

export const getAgencyCSVData = createAsyncThunk('GET AGENCY CSV DATA', async (data, thunkAPI) => {
  const query = `?text=${data?.text}&startDate=${data?.startDate}&endDate=${data?.endDate}&planType=${data?.planType}&subscriptionStatus=${data?.subscriptionStatus}&sortField=${data?.sortField}&sortOrder=${data?.sortOrder}&subscriptionDuration=${data?.subscriptionDuration}&paymentStatus=${data?.paymentStatus}&agencyStatus=${data?.agencyStatus}&originCountry=${data?.originCountry}&paymentGateway=${data?.paymentGateway}&hotelVendor=${data?.hotelVendor}&isSSOEnabled=${data?.isSSOEnabled}`;

  const response = await axios.get(`${URL.AGENCY_CSV_DOWNLOAD}${query}`, thunkAPI);
  return response.data;
});

export const getSearchesCSVData = createAsyncThunk('GET SEARCHES CSV DATA', async (data, thunkAPI) => {
  const query = `?text=${data?.text}&startDate=${data?.startDate}&endDate=${data?.endDate}`;

  const response = await axios.get(`${URL.SEARCHES_CSV_DOWNLOAD}${query}`, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  csvData: null,
};

export const CSVSlice = createSlice({
  name: 'csv',
  initialState,
  reducers: {},
  extraReducers: {
    // get csv data
    [getCSVData.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getCSVData.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = action.payload.data;
    },
    [getCSVData.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },

    // get csv data hotel
    [getCSVDataHotel.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getCSVDataHotel.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = {csv: action.payload.data};
    },
    [getCSVDataHotel.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },

    // get csv data flight
    [getCSVDataFlight.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getCSVDataFlight.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = {csv: action.payload.data};
    },
    [getCSVDataFlight.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },

    // get csv data car
    [getCSVDataCar.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getCSVDataCar.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = {csv: action.payload.data};
    },
    [getCSVDataCar.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },

    // get csv data activity
    [getCSVDataActivity.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getCSVDataActivity.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = {csv: action.payload.data};
    },
    [getCSVDataActivity.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },

    // get agency csv data
    [getAgencyCSVData.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getAgencyCSVData.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = action.payload.data;
    },
    [getAgencyCSVData.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },

    // get searches csv data
    [getSearchesCSVData.pending]: (state) => {
      state.isLoading = true;
      state.csvData = null;
    },
    [getSearchesCSVData.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.csvData = action.payload.data;
    },
    [getSearchesCSVData.rejected]: (state, action) => {
      state.isLoading = false;
      state.csvData = null;
      toast.error(action?.payload?.message);
    },
  },
});

export default CSVSlice.reducer;
